import { Link } from "react-router-dom";
import {
  buildAuctionSpecItems,
  formatAuctionCurrency,
  getAuctionCategoryTrail,
  getAuctionConditionGrade,
  getAuctionCurrentBidLabel,
  getAuctionDetailHref,
  getAuctionLocation,
  getAuctionStartingPriceLabel,
  getAuctionTimeRemaining,
  resolveAuctionRibbon,
} from "./auctionCardHelpers";

export const MAX_COMPARE_AUCTIONS = 3;

export function getAuctionCompareSeller(auction) {
  return auction?.seller_company || auction?.seller_name || "—";
}

export function getAuctionCompareStatus(auction) {
  return resolveAuctionRibbon(auction)?.label || "—";
}

export const AUCTION_COMPARE_ROWS = [
  { key: "starting", label: "Starting Price", getValue: getAuctionStartingPriceLabel },
  { key: "current", label: "Current Bid", getValue: getAuctionCurrentBidLabel },
  {
    key: "bidders",
    label: "Bidders",
    getValue: (auction) => String(auction?.bidder_count ?? auction?.total_bids ?? 0),
  },
  {
    key: "increment",
    label: "Bid Increment",
    getValue: (auction) => formatAuctionCurrency(auction?.bid_increment || 0),
  },
  { key: "time", label: "Time Left", getValue: (auction) => getAuctionTimeRemaining(auction?.end_date) },
  { key: "location", label: "Location", getValue: (auction) => getAuctionLocation(auction) || "—" },
  { key: "seller", label: "Seller", getValue: getAuctionCompareSeller },
  {
    key: "category",
    label: "Category",
    getValue: (auction) => getAuctionCategoryTrail(auction).join(" › ") || "—",
  },
  {
    key: "condition",
    label: "Condition",
    getValue: (auction) => getAuctionConditionGrade(auction) || "—",
  },
  {
    key: "end",
    label: "End Condition",
    getValue: (auction) => auction?.auction_end_condition || "—",
  },
  { key: "status", label: "Status", getValue: getAuctionCompareStatus },
];

export function getAuctionCompareSpecs(auction) {
  return buildAuctionSpecItems(auction).filter((spec) => !spec.empty);
}

export function getAuctionCompareDetailHref(auction) {
  return getAuctionDetailHref(auction);
}
